import React from 'react';
import PropTypes from 'prop-types';
import questionHelperService from '../../services/questionView/QuestionHelperServices';
import utilService from '../../services/UtilService';
import AdditionalResource from './AdditionalResource';
import constants from '../../qti/Constants';

class FileAdditionalResource extends React.PureComponent {
    static propTypes = {
        resource: PropTypes.object.isRequired,
    };

    render() {
        const { resource } = this.props;
        const { title, contentItemId } = resource;
        const pdfJsService = questionHelperService.getServices().pdfJsService;
        const fileCiUrl = utilService.generateUrlForContentItemId(resource.contentItemId, 'pdf', true);

        if (window.offlineMode) {
            const offlineUrl = pdfJsService.getOfflinePdfJsUrl(contentItemId);
            return <AdditionalResource url={offlineUrl} title={title} type={constants.additionalResourceType.FILE} />;
        }

        return <AdditionalResource url={fileCiUrl} title={title} type={constants.additionalResourceType.FILE} />;
    }
}

export default FileAdditionalResource;
